export const capitalizeString = string => string.charAt(0).toUpperCase() + string.slice(1)
export const singularizeString = string => (string.substr(-1) === 's' ? string.slice(0, -1) : string)
